module.exports = __webpack_public_path__ + "fonts/rubik-light-webfont.b39345ea.b39345ea.woff";